export enum WorkMode {
  Remote = 'remote',
  Hybrid = 'hybrid',
  Office = 'office',
}
